import React from "react";

const PILL_CLASS = {
	critical: "monitoring__analysis-strategy-priority-pill--critical",
	high: "monitoring__analysis-strategy-priority-pill--high",
	medium: "monitoring__analysis-strategy-priority-pill--medium",
	low: "monitoring__analysis-strategy-priority-pill--low",
};

export default function PriorityPill({ priority }) {
	const key = priority ?? "low";
	return (
		<span
			className={`monitoring__analysis-strategy-priority-pill ${
				PILL_CLASS[key] ?? PILL_CLASS.low
			}`}
		>
			{key}
		</span>
	);
}
